import dayjs from "dayjs";

export const DEFAULT_DAY_SLOT_RANGE = {
  minTime: "00:00:00",
  maxTime: "24:00:00",
};

export const getDateKey = (value) => dayjs(value).format("YYYY-MM-DD");

const formatSlotTime = (value) => value.format("HH:mm:ss");

const getRoundedSlotMaxTime = (lastEnd, dateKey) => {
  const roundedEnd =
    lastEnd.minute() === 0 && lastEnd.second() === 0 && lastEnd.millisecond() === 0
      ? lastEnd
      : lastEnd.add(1, "hour").startOf("hour");

  return getDateKey(roundedEnd) !== dateKey ? DEFAULT_DAY_SLOT_RANGE.maxTime : formatSlotTime(roundedEnd);
};

const getEventDateTime = (eventLike, field) => {
  const directValue = eventLike?.[field];

  if (directValue) return dayjs(directValue);

  const match = eventLike?.extendedProps?.match ?? eventLike?.match;
  const matchData = match?.data;

  if (!matchData) return null;

  const fallbackValue =
    field === "start"
      ? (matchData.scheduled_at ?? matchData.start_at)
      : (matchData.ends_at ?? matchData.end_at ?? matchData.scheduled_at ?? matchData.start_at);

  return fallbackValue ? dayjs(fallbackValue) : null;
};

export function getSlotRangeForDate(events, dateKey) {
  const eventsForDate = events
    .map((event) => ({
      start: getEventDateTime(event, "start"),
      end: getEventDateTime(event, "end"),
    }))
    .filter(({ start }) => start?.isValid() && getDateKey(start) === dateKey);

  if (eventsForDate.length === 0) return DEFAULT_DAY_SLOT_RANGE;

  const firstStart = eventsForDate.reduce(
    (currentMin, event) => (event.start.isBefore(currentMin) ? event.start : currentMin),
    eventsForDate[0].start,
  );
  const lastEnd = eventsForDate.reduce(
    (currentMax, event) => {
      const eventEnd = event.end?.isValid() ? event.end : event.start;
      return eventEnd.isAfter(currentMax) ? eventEnd : currentMax;
    },
    eventsForDate[0].end?.isValid() ? eventsForDate[0].end : eventsForDate[0].start,
  );

  return {
    minTime: formatSlotTime(firstStart.startOf("hour")),
    maxTime: getRoundedSlotMaxTime(lastEnd, dateKey),
  };
}
